import React, { useState } from 'react'
import styled from 'styled-components'
import AddIcon from '@mui/icons-material/Add';
import CompareIcon from '@mui/icons-material/Compare';
import SimulateIcon from '../../src/assets/icons/Simulate.png'
import ComparisonIcon from '../../src/assets/icons/ComparisonIcon.png'
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Tick from "../../src/assets/icons/Tick.png";
import Minus from "../../src/assets/icons/Minus.png";
import FlowOfPlay from "../../src/assets/icons/FlowOfPlay.png";
import ThreatMap from "../../src/assets/icons/ThreatMap.png";
import AreasOfControl from "../../src/assets/icons/AreasOfControl.png";
import SystemFit from "../../src/assets/icons/Systemfit.png";
import OptimalPathways from "../../src/assets/icons/OptimalPathways.png";
import PassingNet from "../../src/assets/icons/PassingNet.png";
import PassingAttack from "../../src/assets/icons/PassingAttack.png";
import ArrowUp from "../../src/assets/icons/ArrowUp.png";
import ArrowDown from "../../src/assets/icons/ArrowDown.png";
import LabelText from "./LabelText";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Clubs from "../../src/assets/sidebarIcons/Clubs.png";
import RemoveIcon from "@mui/icons-material/Remove";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Sort from "../../src/assets/icons/SortDark.png";
import PlotResult from '../../src/assets/icons/PlotResultIcon.png';
import Pitch3D from '../../src/assets/icons/Pitch3D.png';
import Pitch2D from '../../src/assets/icons/Pitch2D.png';
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ExpandView from "../../src/assets/icons/ExpandView.svg";
import Expander from "../../src/assets/icons/expander.png";
import RefreshIcon from '@mui/icons-material/Refresh';
import PlayerComparisionIcon from '../../src/assets/icons/PlayerComparision.svg'
import TableIcon from '../../src/assets/icons/TableIcon.svg'
import PlotIcon from '../../src/assets/icons/PlotIcon.svg'
import TrackerIcon from '../../src/assets/icons/TrackerIcon.svg'
import PitchIcon from '../../src/assets/icons/PitchIcon.svg'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ComparisonByAttributeSelectionIcon from  '../../src/assets/icons/comparisonbyselection.svg'
import SearchIcon from  '../../src/assets/icons/SearchIcon.svg'
import PlusIcon from  '../../src/assets/icons/plusIcon.svg'
import MinusIcon from  '../../src/assets/icons/minusIcon.svg'
import HandIcon from '../../src/assets/icons/handIcon.svg'

const getColor = (isSelected: boolean, theme: any) =>
  isSelected ? 'var(--Brand-black-500, #FFF)' : theme.playerColor;

const getBackground = (isSelected: boolean, disabled: boolean, theme: any, buttonType: string) =>
  disabled ? theme.buttonBorderColor : (isSelected && buttonType === 'pitchWidgets') ?
    'var(--Brand-green-1-500, #00D1A8)' : (isSelected && buttonType !== 'pitchWidgets') ? 'var(--Shades-UI-Blue-blue-500, #00A1E4)' : theme.secondaryButtonBackground;

const getIconColor = (isSelected: boolean, disabled: boolean, theme: any) =>
  disabled ? theme.swapSamePositionPlayerBorder : isSelected ? 'var(--Brand-black-500, #111)' : theme.playerColor;

const getIconFilter = (disabled: boolean, isSelected: boolean, theme: any) =>
  (disabled) ? 'grayscale(100%)' : isSelected ? 'grayscale(100%) brightness(0) invert(1)' : (theme.playerColor === 'var(--Brand-white-500, #FFF)' ? 'grayscale(100%) brightness(0) invert(1)' : 'none');


export const StyledButton = styled.button<{ isSelected?: boolean, disabled?: boolean, buttonType?: string}>`
  display: flex;
  padding: 8px 12px;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme, buttonType, isSelected, disabled }) =>
    (buttonType !== 'pitchWidgets' && isSelected) ? 'var(--Shades-UI-Blue-blue-600, #0093CF)' : theme.secondaryButtonBorderColor};
  color:${({ isSelected, theme }) => getColor(isSelected || false, theme)};
  background: ${({ isSelected, disabled, theme, buttonType }) => getBackground(isSelected || false, disabled || false, theme, buttonType || 'normal')};
  height: fit-content;
  
  & .secondary-cta-icon {
    color:${({ isSelected, disabled, theme }) => getIconColor(isSelected || false, disabled || false, theme)};
    filter: ${({ theme, isSelected, disabled }) => getIconFilter(disabled || false, isSelected || false, theme)};
    height: 24px;
    width: 24px;
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  }
    &. secondary-onpitch-icon{
    color:${({ isSelected, disabled, theme }) => getIconColor(isSelected || false, disabled || false, theme)};
    filter: ${({ theme, isSelected, disabled }) => getIconFilter(disabled || false, isSelected || false, theme)};
    height: 20px;
    width: 20px;
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    }
  & .secondary-cta-text {
    color:${({ isSelected, theme }) => getColor(isSelected || false, theme)};
  }

   &:hover {
    border-radius: ${({ buttonType }) => buttonType === 'pitchWidgets' ? '2px' : '4px'};
    border: 1px solid ${({ theme }) => theme.emptyDataBorder};
    background: ${({ theme, buttonType }) => buttonType === 'pitchWidgets' ? theme.secondaryButtonBorderColor : theme.filterdropdownBorder};   
  }
    &:disabled {
        border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
        background: ${({ theme }) => theme.buttonBorderColor};
        cursor: not-allowed;
    }
`;

interface SecondaryButtonProps {
  label?: React.ReactNode;
  iconType?: string;
  // onClick?: (event: any) => any;
  onClick?: any;
  className?: string;
  disabled?: boolean;
  isSelected?: boolean;
  buttonType?: string;
  isRemoveText?: boolean
}

const iconMap: { [key: string]: JSX.Element } = {
  add: <AddIcon className="secondary-cta-icon" />,
  compare: <img src={ComparisonIcon} className="secondary-cta-icon" alt="ComparisonIcon" />,
  simulate: <img src={SimulateIcon} className="secondary-cta-icon" alt="SimulateIcon" />,
  bookmark: <BookmarkBorderOutlinedIcon className="secondary-cta-icon" />,
  share: <ShareOutlinedIcon className="secondary-cta-icon" />,
  tick: <img src={Tick} className="secondary-cta-icon" alt="ComparisonIcon" />,
  arrowup: <img src={ArrowUp} className="secondary-cta-icon" alt="ComparisonIcon" />,
  arrowdown: <img src={ArrowDown} className="secondary-cta-icon" alt="ComparisonIcon" />,
  keyboardarrowdown: <KeyboardArrowDownIcon className="secondary-cta-icon" />,
  keyboardarrowup: <KeyboardArrowUpIcon className="secondary-cta-icon" />,
  team: <img src={Clubs} className="secondary-cta-icon" alt="teamIcon" />,
  minus: <img src={Minus} className="secondary-cta-icon" alt="minusIcon" />,
  riskmap: <img src={Minus} className="secondary-cta-icon" alt="minusIcon" />,
  flowofplay: <img src={FlowOfPlay} className="secondary-cta-icon" alt="flowOfPlayIcon" />,
  threatmap: <img src={ThreatMap} className="secondary-cta-icon" alt="threatMapIcon" />,
  systemfit: <img src={SystemFit} className="secondary-cta-icon" alt="systemFitIcon" />,
  passingnetwork: <img src={PassingNet} className="secondary-cta-icon" alt="passingNetworkIcon" />,
  optimalpathways: <img src={OptimalPathways} className="secondary-cta-icon" alt="optimalPathwaysIcon" />,
  passingattack: <img src={PassingAttack} className="secondary-cta-icon" alt="optimalPathwaysIcon" />,
  areasofcontrol: <img src={AreasOfControl} className="secondary-cta-icon" alt="areasOfControlIcon" />,
  remove: <RemoveIcon className="secondary-cta-icon" />,
  keyboardarrowleft: <KeyboardArrowLeftIcon className="secondary-cta-icon" />,
  keyboardarrowright: <KeyboardArrowRightIcon className="secondary-cta-icon" />,
  arrowleft: <KeyboardArrowLeftIcon className="secondary-onpitch-icon" />,
  arrowright: <KeyboardArrowRightIcon className="secondary-onpitch-icon" />,
  menu: <MoreVertIcon className='secondary-cta-icon'/>,
  playarrow: <PlayArrowIcon className="secondary-cta-icon" />,
  profile: <PersonOutlineOutlinedIcon className="secondary-cta-icon" />,
  sort: <img src={Sort} className='secondary-cta-icon' alt='teamIcon' />,
  plotresult: <img src={PlotResult} className='secondary-cta-icon' alt='teamIcon' />,
  pitch2d: <img src={Pitch2D} className='secondary-cta-icon' alt='pitch2DIcon' />,
  pitch3d: <img src={Pitch3D} className='secondary-cta-icon' alt='pitch3DIcon' />,
  expandedview: <img src={ExpandView} className='secondary-cta-icon' alt='expandView' />,
  expander: <img src={Expander} className='secondary-cta-icon' alt='expandView' />,
  refresh: <RefreshIcon className='secondary-cta-icon' />,
  playercomparison: <img src={PlayerComparisionIcon} className='secondary-cta-icon' alt='PlayerComparision' />,
  table: <img src={TableIcon} className='secondary-cta-icon' alt='table' />,
  plot: <img src={PlotIcon} className='secondary-cta-icon' alt='plot' />,
  tracker: <img src={TrackerIcon} className='secondary-cta-icon' alt='tracker' />,
  zoomin :<img src={PlusIcon} className='secondary-cta-icon' />,
  zoomout :<RemoveIcon className='secondary-cta-icon'/>,
  pitch: <img src={PitchIcon} className='secondary-cta-icon' alt='pitch' />,
  score :<img src={ComparisonByAttributeSelectionIcon} className='secondary-cta-icon'/>,
  hand: <img src={HandIcon} className='secondary-cta-icon'/>,
};

const SecondaryButton: React.FC<SecondaryButtonProps> = ({ label, iconType, onClick, isRemoveText, className, disabled = false, isSelected = false, buttonType }) => {
  const icon = iconType ? iconMap[iconType.toLowerCase()] : null;
  //const labelIcon = label ? labelIcons[label] || label : '';

  return (
    <StyledButton onClick={onClick} className={className}
      disabled={disabled} isSelected={isSelected} buttonType={buttonType}>
      {icon}
      {label && <LabelText className={disabled ? "disabled-text" : isRemoveText ? "remove-text" : "secondary-cta-text"}>{label}</LabelText>}
    </StyledButton>
  );
};

export default SecondaryButton;
